<div class="grid hide-on-print">
  <div class="col-12">
    <p-toolbar styleClass="header-background">
      <ng-template pTemplate="start">

        <div class="flex flex-column ">
          <div class="flex " style="margin-left: 13px;"><img src="../../assets/images/postnord.svg" /></div>
        </div>
      </ng-template>
      <ng-template pTemplate="center">
      </ng-template>
      <ng-template pTemplate="end">
        <span>
          <p-menu #profileMenu [popup]="true" [model]="profileItems"></p-menu>
          <div class="flex align-items-center">
            @if (isAdminGroup || isCustomsGroup) {
              <app-parcel-summary></app-parcel-summary>
            }
            <button pButton pRipple (click)="profileMenu.toggle($event)" aria-haspopup="true"
              aria-controls="profileMenu"
              class="p-link inline-flex justify-content-center align-items-center text-white h-3rem w-3rem border-circle hover:bg-white-alpha-10 transition-all transition-duration-200">
              <i class="pi pi-user text-2xl"></i>
            </button>
          </div>
        </span>

      </ng-template>
    </p-toolbar>
  </div>
</div>

<app-export-barcodes [visible]="visible" (onClose)="eventClose()"></app-export-barcodes>